import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { myFilesFolderMove } from '../../../../../services/CommonService';
import { toast } from 'react-toastify';

const MoveModal = ({
  show,
  onHide,
  loading,
  modalType,
  selectedItems,
  selectedItem,
  availableFolders,
  fetchingFolders,
  userId,
  onMove,
  setLoading,
  setRefreshTrigger,
  closeModal,
  setSelectedItems
}) => {
  const [selectedDestinationFolder, setSelectedDestinationFolder] = useState(null);

  const handleMove = async () => {
    if (!selectedDestinationFolder) {
      toast.error("Please select a destination folder");
      return;
    }

    // Debug logs to understand the data structure
    console.log('=== MOVE DEBUG ===');
    console.log('selectedItems:', selectedItems);
    console.log('selectedItem:', selectedItem);
    console.log('modalType:', modalType);

    setLoading(true);
    try {
      let folderIds = [];
      let fileIds = [];
      let itemsToMove = [];

      // Handle different modal types
      if (modalType === 'multi' && selectedItems && selectedItems.length > 0) {
        // Multiple items selected
        folderIds = selectedItems
          .filter((item) => item.type === 'folder')
          .map((item) => item.id)
          .filter(id => id !== undefined && id !== null);

        fileIds = selectedItems
          .filter((item) => item.type === 'file')
          .map((item) => item.id)
          .filter(id => id !== undefined && id !== null);

        itemsToMove = selectedItems;
      } else if (selectedItem) {
        // Single item selected
        if (modalType === 'folder') {
          folderIds = [selectedItem.id];
          itemsToMove = [{ ...selectedItem, type: 'folder' }];
        } else if (modalType === 'file') {
          fileIds = [selectedItem.id];
          itemsToMove = [{ ...selectedItem, type: 'file' }];
        }
      }

      console.log('Final folderIds:', folderIds);
      console.log('Final fileIds:', fileIds);

      // Validate that we have valid IDs
      if (folderIds.length === 0 && fileIds.length === 0) {
        toast.error("No valid items found to move");
        return;
      }

      const payload = {
        user_id: userId,
        folder_ids: folderIds,
        file_ids: fileIds,
        target_folder_id: selectedDestinationFolder.id === null ? null : selectedDestinationFolder.id
      };

      console.log('Final payload:', payload);
      await myFilesFolderMove(payload);
      toast.success(`${itemsToMove.length} Item${itemsToMove.length > 1 ? 's' : ''} moved successfully`);
      closeModal();
      setRefreshTrigger(Date.now());
      setSelectedItems([]);
      if (onMove) {
        onMove({
          movedItems: itemsToMove,
          targetFolder: selectedDestinationFolder,
          userId,
        });
      }
    } catch (err) {
      console.error(`Error moving items:`, err);
      toast.error(err.message || `Failed to move items`);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;
  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={(e) => e.target === e.currentTarget && onHide()}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              Move {modalType === 'multi' ? `${selectedItems.length} Item` : modalType === 'folder' ? 'Folder' : 'File'}
            </h5>
            <Button
              variant="link"
              onClick={onHide}
              disabled={loading}
              className="btn btn-close"
            >
              <i className="bi bi-x-lg text-dark" />
            </Button>
          </div>
          <div className="modal-body">
            <p className="modal-move-description">
              Select the destination folder for {modalType === 'multi'
                ? `${selectedItems.length} selected item`
                : `"${selectedItem?.folder_name || selectedItem?.file_name}"`}.
            </p>
            <div className="modal-body-input-container">
              <label className="mb-1">Destination Folder</label>
              <select
                className="modal-body-input rounded"
                value={selectedDestinationFolder ? selectedDestinationFolder.id : ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  const folder = availableFolders.find((f) =>
                    f.id === null ? selectedValue === "null" : f.id === parseInt(selectedValue)
                  );
                  setSelectedDestinationFolder(folder || null);
                }}
                disabled={fetchingFolders || availableFolders.length === 0}
              >
                <option value="" disabled>
                  Select a folder
                </option>
                <option value="null">Root Directory</option>
                {availableFolders
                  .filter((folder) => folder.id !== null)
                  .map((folder) => (
                    <option key={folder.id} value={folder.id}>
                      {folder.folder_name}
                    </option>
                  ))}
              </select>
            </div>
            {fetchingFolders ? (
              <div className="modal-loading-text">
                Loading folders...
              </div>
            ) : (
              availableFolders.length === 0 && (
                <div className="modal-loading-text">
                  No available folders found
                </div>
              )
            )}
          </div>
          <div className="modal-footer">
            <Button
              variant="secondary"
              onClick={onHide}
              disabled={loading}
              className="modal-footer-button"
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleMove}
              disabled={!selectedDestinationFolder || loading}
              className="modal-footer-button"
            >
              {loading ? "Moving..." : "Move"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveModal; 